// src/libs/preBuild/LayerWrapper/index.js (수정)
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useLayer } from 'src/contexts/LayerContext';

import AlertLayer from '~/libs/preBuild/PopupLayer/AlertLayer';
import ConfirmLayer from '~/libs/preBuild/PopupLayer/ConfirmLayer';

const LayerWrapper = () => {
    const { layerState, hideLayer } = useLayer();
    const { isActive, type, form, hiddenBottomButton, callback } = layerState;

    // 앵커 엘리먼트를 저장할 상태 (초기값은 null)
    const [portalRoot, setPortalRoot] = useState(null);

    useEffect(() => {
        if (typeof document !== 'undefined') {
            // ⭐️ 1. SSR 환경을 피하고 브라우저에서만 #layer-root를 찾음
            const root = document.getElementById('layer-root');
            setPortalRoot(root);

            if (!root) {
                console.error(
                    'Portal Root (#layer-root)을 찾을 수 없음! gatsby-ssr.js 확인 필요.'
                );
            } else {
                console.log('Portal Root (#layer-root) 찾음:', root);
            }
        }
    }, []);

    const handleConfirm = () => {
        callback();
        hideLayer();
    };

    // ⭐️ 2. 렌더링 조건 통합 (isActive와 portalRoot 둘 다 유효해야 함)
    // portalRoot가 null이면 (SSR 시점이나 엘리먼트를 찾지 못했을 때) 렌더링하지 않음.
    if (!isActive || !portalRoot) {
        return null;
    }

    // 렌더링할 모달 콘텐츠
    const modalContent = (
        <>
            <div className={`_Modal_UI_Wrap dimed active`}>
                <div className={'modal-container'}>
                    {type === 'confirm' && (
                        <ConfirmLayer
                            form={form}
                            hiddenBottomButton={hiddenBottomButton}
                            onClose={hideLayer}
                            onConfirm={handleConfirm}
                        />
                    )}
                    {type === 'alert' && (
                        <AlertLayer form={form} onClose={handleConfirm} />
                    )}
                </div>
            </div>

        </>
    );

    // ⭐️ 3. Portal 실행: document.body 대신 portalRoot 상태를 타겟으로 지정
    // isActive와 portalRoot가 null이 아님을 보장했기 때문에 안전합니다.
    return ReactDOM.createPortal(modalContent, portalRoot);
};
export default LayerWrapper;
